import { Button, Table, Tooltip, Typography } from "antd";
import styles from "./dashboard.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { downloadDataAsCSV } from "../../utils/downloadFile";
import { useNavigate } from "react-router-dom";

const OrderSummary: React.FC<{ templateAggregations: any }> = ({
  templateAggregations,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "TEMPLATE",
      dataIndex: "templateName",
      key: "templateName",
    },
    {
      title: "SIZE",
      dataIndex: "size",
      key: "size",
      width: 70,
    },
    {
      title: "SUBMISSIONS",
      dataIndex: "submissions",
      key: "submissions",
      align: "right" as const,
      width: 110,
      render: (_: any, record: any) => (
        <Typography
          className={styles.tableData}
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate("/Orders", {
              state: { templateId: record.templateId, excludeErrors: false },
            })
          }
        >
          {record.submissions.toLocaleString()}
        </Typography>
      ),
    },
    {
      title: "ERRORS",
      dataIndex: "errors",
      key: "errors",
      align: "right" as const,
      width: 80,
      render: (_: any, record: any) => (
        <Typography 
          className={`${record.errors? styles.tableData : ''}`}
          onClick={() =>
            (record.errors ? navigate("/Orders", {
              state: { templateId: record.templateId, excludeErrors: true },
            }) : '')
          }
        >
          {record.errors ? record.errors.toLocaleString() : "-"}
        </Typography>
      ),
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "quantity",
      width: 100,
      align: "right" as const,
      render: (_: any, record: any) => (
        record.quantity ? record.quantity.toLocaleString() : "-"
      ),
    },
  ];

  const downloadCSV = () => {
    downloadDataAsCSV(templateAggregations, "orderSummary.csv");
  };

  return (
    <div className={styles.dashboardTable}>
      <div className={styles.orderSummaryHeader}>
        <span
          style={{
            fontWeight: 700,
          }}
        >
          Order Summary
        </span>

        <Tooltip title="Download summary report">
          <Button
            icon={<FontAwesomeIcon icon={faDownload} style={{width: '16px', height:'16px'}}/>}
            onClick={downloadCSV}
            className={styles.downloadButton}
          />
        </Tooltip>
      </div>
      <Table
        dataSource={templateAggregations}
        columns={columns}
        pagination={false}
        sticky={true}
        locale={{ emptyText: "No rows found" }}
      />
    </div>
  );
};

export default OrderSummary;
